<template>
    <modal :show="show" v-if="currentCampaign">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Edit {{ currentCampaign.name }}</modal-header>
        </div>

        <div>
          <form-group>
            <field name="Name" :value="editCampaign.name" v-model="editCampaign.name"/>
          </form-group>
          <form-group>
            <field name="Campaign Job Number (Optional)" :value="editCampaign.campaign_job_number" v-model="editCampaign.campaign_job_number"/>
          </form-group>
          <form-group>
            <dropdown name="Client" :options="clientOptions" v-model="editCampaign.client"
                      :current="editCampaign.client"/>
          </form-group>
          <form-group>
            <dropdown name="Is Archived?" :options="archived.options" v-model="editCampaign.is_archived" :current="editCampaign.is_archived"/>
          </form-group>
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import Field from '@/components/Form/Field/field'
import Steps from '@/components/Steps/steps'
import {modalMixin} from '@/mixins/modalMixin'
import {campaignMixin} from '@/mixins/campaignMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_edit_campaign',
  mixins: [modalMixin, campaignMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    Steps,
    FormGroup,
    Dropdown,
    Field
  },
  props: {
    show: Boolean,
    campaignId: String,
    currentCampaign: Object,
    callback: { type: Function, default: null }
  },
  data: () => ({
    showEdit: false,
    editCampaign: {
      name: '',
      client: '',
      campaign_job_number: '',
      is_archived: false
    },
    archived: {
      options: [
        {
          name: 'No',
          value: false
        },
        {
          name: 'Yes',
          value: true
        }
      ]
    }
  }),
  created () {},
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      this.close()
      this.updateCampaign(this.editCampaign).then(() => {
        this.getClientCampaigns(this.currentCampaign.client.hash_id).then(() => {
          if (this.callback) this.callback()
          this.addNotification('success', `${this.currentCampaign.name} campaign successfully updated.`) // This needs to be the new name not old name
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    }
  },
  watch: {
    currentCampaign: function () {
      if (this.currentCampaign) {
        this.editCampaign = {
          id: this.campaignId,
          name: this.currentCampaign.name,
          client: this.currentCampaign.client.hash_id,
          is_archived: this.currentCampaign.is_archived,
          campaign_job_number: this.currentCampaign.campaign_job_number
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/campaigns/modal-edit-campaign.vue